import styled from "styled-components";

export const Wrapper = styled.div<{ offset: number; visible: boolean }>`
/*   position: absolute;
  top: -70px; */
  /* transform: translate3d(0, ${({ offset }) => offset}px, 0); */
  left: 0;
  width: 100%;
  max-height: ${({ visible }) => (visible ? "220px" : "0")};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  overflow: hidden;
  /* z-index: 100; */
  transition: transform 0.4s, max-height 0.24s ease, opacity 0.2s ease;
  pointer-events: none;
`;

export const Inner = styled.div`
  display: flex;
  justify-content: center;
  margin: 0px auto;
  max-width: 824px;
  padding-top: 30px;
`;

export const PopupWrapper = styled.div<{ show: boolean; size: { width: string; height: string }; backgroundImage ?: string }>`
  display: flex;
  cursor: ${({ show }) => (show ? "initial" : "pointer")};
  /* width: ${({ size }) => size.width}; */
  width: 100%;
  height: auto;
  transition: ${({ show }) => (show ? "all 0.3s ease-in-out" : "all 0.3s ease-in-out 0.3s")};
  overflow: hidden;
  pointer-events: auto;
  border-radius: 12px;
  // background: linear-gradient(180deg, #008E9F 0%, #00505A 100%);
  box-shadow: 0 0 8px 2px rgba(50, 112, 119, 0.20);
  color: ${({ backgroundImage }) => backgroundImage?.trim() ? "inherit" : "var(--color-white)"};
  background: ${({ backgroundImage }) => backgroundImage?.trim() ? `url(${backgroundImage}) left center / cover no-repeat` : "var(--color-petrol)"};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left;

  // @media (min-width: 768px) {
  //   width: 85%; 
  // } 
`;

export const PopupContent = styled.div<{ show: boolean }>`
  transition: ${({ show }) => (show ? "opacity 0.3s ease-in-out 0.3s" : "opacity 0.3s ease-in-out")};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 25px;
`;

export const PopupCollapsButton = styled.div`
  width: 22px;
  height: 22px;
  position: absolute;
  top: 0px;
  right: 0px;
  border: 1px solid var(--color-coal-25);
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background-color: var(--color-coal-5);
  transition: background-color 0.2s;
  cursor: pointer;

  &:hover {
    background-color: var(--color-coal-15);
  }
`;

export const PopupTitle = styled.p`
  margin: 0;
  margin-bottom: 4px;
  text-align: center;
  text-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
  font-size: 23px;
  line-height: normal;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  padding-left: 12px;
  padding-right: 12px;
  @media (min-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  } 
`;

export const PopupSubTitle = styled.p`
  display: inline-flex;
  margin-bottom: 0;
  font-weight: 500;
  color: var(--ase---White, #FFF);
  text-align: center;
  font-size: 12px;
  text-decoration-line: underline;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
`;

export const PopupAvailable = styled.p`
  margin: 0;
  font-size: 11px;
`;

export const PulseCircle = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--color-green);
  margin-right: 4px;
  animation: ASEOnlinePulse 2s infinite;
`;

export const Gif = styled.img`
  width: 151px;
  height: 151px;
  position: relative;
`;
